import { useId } from "react";
import { Info } from "lucide-react";
import styles from "./InfoTip.module.css";

// Info icon that reveals `text` on hover or keyboard focus.
// `placement="bottom"` opens it downward, for spots where content above is clipped (e.g. table headers).
export default function InfoTip({ text, size = 14, placement = "top" }) {
  const id = useId();
  return (
    <span className={styles.wrap} tabIndex={0} aria-describedby={id}>
      <Info size={size} className={styles.icon} aria-hidden="true" />
      <span id={id} role="tooltip" className={`${styles.tip} ${placement === "bottom" ? styles.tipBottom : ""}`}>{text}</span>
    </span>
  );
}

// `label` followed by an InfoTip, with the icon glued to the label's last word so
// a label that wraps can't leave the icon alone on a line of its own.
export function LabelWithTip({ label, ...tip }) {
  if (typeof label !== "string") {
    return <>{label}<InfoTip {...tip} /></>;
  }
  const cut = label.trimEnd().lastIndexOf(" ") + 1;
  return (
    <>
      {label.slice(0, cut)}
      <span className={styles.glue}>
        {label.slice(cut)}
        <InfoTip {...tip} />
      </span>
    </>
  );
}
